<template>
    <div class="wrapper">
        <div class="banner"></div>
        <ul class="list">
            <li class="element">
                <router-link to="/order">                    
                    <p class="text">Order History</p>
                    <i class="icon icon-arrow-right"></i>
                </router-link>    
            </li>
            <li class="element">
                <router-link to="/feedback">                    
                    <p class="text">FeedBack</p>
                    <i class="icon icon-arrow-right"></i>
                </router-link>
            </li>
            <li class="element">
                <router-link to="/personal/help">                    
                    <p class="text">Help Center</p>
                    <i class="icon icon-arrow-right"></i>
                </router-link>
            </li>
            <!-- <li class="element">
                <router-link to="/testNotification">                    
                    <p class="text">Notification</p>
                    <i class="icon icon-arrow-right"></i>
                </router-link>
            </li> -->
            <!-- <li class="element">
                <router-link to="/personal/aboutus">
                    <p class="text">About Us</p>
                    <i class="icon icon-arrow-right"></i>
                </router-link>    
            </li>                         -->
            <li class="element">
                <a href="javascript:void(0)" @click="quit">                    
                    <p class="text">Quit</p>
                    <i class="icon icon-arrow-right"></i>
                </a>
            </li>
        </ul>        
        
        <!-- <div class="info">
            <div class="info-top">
                <p class="it-text">If you have any questions, please feel free to contact us. We will serve you wholeheartedly</p>
            </div>
            <ul class="info-list">
                <li class="info-element">
                    <i class="icon icon-p-phone"></i>
                    <span class="info-text">Tel: &nbsp;{{ obj.phone }}</span>
                </li>
                <li class="info-element">
                    <i class="icon icon-p-mail"></i>
                    <span class="info-text">Email: &nbsp;{{ obj.email }}</span>
                </li>
                <li class="info-element">
                    <i class="icon icon-p-time"></i>
                    <span class="info-text">Working Time: &nbsp;{{ obj.time }}</span>
                </li>
            </ul>
        </div> -->
    </div>
</template>
<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
// import { systemConfig } from '@api/index'
// import { onMounted, reactive } from 'vue'
export default {
    setup () {
        const store = useStore()        
        const router = useRouter()        
        const quit = () => {
            store.dispatch('clearToken')
            router.replace({
                path: '/login'
            })
        }        
        const back = () => {
            window.goBack.postMessage("");
            // window.history.go(-1)
        }
        return { quit,back }
        
    }
}
</script>
<style lang="less" scoped>
@import "assets/less/icon.less";
    .info{
        .info-top{
            width: 686px;
            height: 234px;
            margin:0 auto;
            position: relative;
            background: url("~assets/images/personal/p-bg2.png") no-repeat;
            background-size: 100% 100%;
            .it-text{
                width:500px;
                position:absolute;
                font-size: 28px;
                color:#3559F3;
                line-height: 1.5;
                left:200px;
                top:50px;
            }
        }
        .info-list{
            background: #5e5e73;
            width: 636px;
            height: 200px;
            margin: -50px auto 50px auto;;
            padding:100px 0 0 50px;
            .info-element{
                display:flex;
                justify-content: flex-start;
                margin-bottom: 30px;
                .icon{
                    flex: 0 0 auto;
                    margin-right: 50px;
                }
                .info-text{
                    color:#3559F3;
                    font-size: 28px;
                    flex: 1 0 auto;
                }
            }
        }
    }

    .wrapper{
        .list{
            overflow:hidden;
            padding:0 35px;
            margin-top: 50px;
            .element{
                float:left;
                width: 620px;
                height:80px;
                margin-right: 24px; 
                padding:30px;  
                margin-bottom: 30px;
                border-radius: 15px;  
                background: #5e5e73;
                box-shadow: 8px 8px 10px 0px rgba(0,0,0,0.0800);;
                a{
                    display: flex;                
                    justify-content: space-between;
                    align-items: center;
                    height:100%;
                    .icon{
                        margin:0
                    }
                }                       
                
                .text{
                    width:180px;
                    text-align: left;
                    font-size: 28px;
                    color:#fff;
                }

            
            }
        }
        .banner{
            position:relative;
            width: 114px;
            height:80px;
            background:url("~assets/images/logo.png") no-repeat;
            background-size: 100% 100%;
            margin: 30px auto;
            padding:50px 30px;
            .title{
                font-size: 56px;
                color:#000;
                position:absolute;
                top:200px;
                left:70px;
                line-height: 1.5;
            }
            .left{
                position: absolute;
                top:120px;
                left:30px;
                color:#fff;
                font-size:40px;
            }            
        }

    }
</style>